import PropTypes from 'prop-types'
import React, { Component } from 'react'
import ReactDOMServer from 'react-dom/server'
import Parser from 'html-react-parser'
import { connect } from 'react-redux'
import classnames from 'classnames'
import { Link } from 'react-router-dom'
import stateSelector from 'reduxModules/subscriptions/selectors'
import { subscriptionPlansDispatchers as dispatchSelector } from 'reduxModules/subscriptions/dispatchers'
import _ from 'lodash'
import getPlanIcon from '../../utils/getPlanIcon'
import Tooltip from '../../generic/Tooltip'
import './styles.css'

export class SubscriptionPlanList extends Component {
  constructor(props, context) {
    super(props, context)
    this.getDiscountedPrice = this.getDiscountedPrice.bind(this)
    this.filterSubscriptionPlans = this.filterSubscriptionPlans.bind(this)
    this.filterSubscriptionPlansMobile =
      this.filterSubscriptionPlansMobile.bind(this)
    this.htmlParser = Parser
  }

  getDiscountedPrice(plan) {
    const globalPromo = this.props.globalPromo
    if (
      this.props.isGlobalPromoEnabled &&
      globalPromo.plans &&
      plan.id &&
      globalPromo.plans[plan.id]
    )
      return this.props.globalPromo.plans[plan.id].priceDiscountMonthly
    return plan.priceMonthly
  }

  getMonthlyStrikethroughPrice() {
    const { globalPromo, isGlobalPromoEnabled, plans } = this.props
    if (isGlobalPromoEnabled && globalPromo.plans) {
      const monthlyPlan = plans.find(
        (p) => p.name.toLowerCase() === 'monthly'
      )
      if (monthlyPlan && globalPromo.plans[monthlyPlan.id])
        return `$${globalPromo.plans[monthlyPlan.id].priceDiscountMonthly}`
    }
    return '$59.99'
  }

  filterSubscriptionPlans(plan) {
    return (
      !(!this.props.isSubscribed && plan.name === 'Apprentice') &&
      !(this.props.currentPlanName === 'Apprentice' && plan.name === 'Basic') &&
      !(this.props.currentPlanName === 'Basic' && plan.name === 'Apprentice') &&
      !(this.props.currentPlan > 1 && plan.name === 'Apprentice')
    )
  }

  filterSubscriptionPlansMobile(plan) {
    return this.filterSubscriptionPlans(plan) && plan.name !== 'Group Learning'
  }

  renderDesktop() {
    const { globalPromo, isGlobalPromoEnabled } = this.props

    if (_.isEmpty(this.props.plans)) return null

    return (
      <section id="SubscriptionPlanList">
        <div className="col large">
          <div className="row header">
            <h3>What you get</h3>
          </div>
          <div className="row">
            <i
              aria-label="Online Course Library icon"
              className="icon-play"
              role="presentation"
            />
            <span className="large-description">Online Course library</span>
            <Tooltip message="Explore 1000+ hours of on-demand instruction by the world's finest artists & technical wizards" />
          </div>
          <div className="row">
            <img
              alt="Access to pathways icon"
              className="icon-learning-path"
              src="/global/assets/images/icons/learningIcon.svg"
            />
            <span className="large-description">Access to Pathways</span>
            <Tooltip message="Enjoy the freedom of online education with the guidance of a traditional curriculum" />
          </div>
          <div className="row">
            <i
              aria-label="Watch on your computer, phone, or tablet icon"
              className="icon-mobilepluspc"
              role="presentation"
            />
            <span className="large-description">
              Watch on your computer, phone, or tablet
            </span>
            <Tooltip message="Learn on your own time and at your own pace from your computer, phone, or tablet" />
          </div>
          {!isGlobalPromoEnabled && (
            <div className="row">
              <i
                aria-label="Live Course Discounts icon"
                className="icon-discountb-1"
                role="presentation"
              />
              <span className="large-description">Live Course Discounts</span>
              <Tooltip message="Subscribers are eligible for discounted enrollment in our interactive live online courses" />
            </div>
          )}
          {isGlobalPromoEnabled && (
            <div className="row">
              <i
                aria-label="Discounts icon"
                className="icon-save"
                role="presentation"
              />
              <span className="large-description">7-Day Free Trial</span>
            </div>
          )}
          <div className="row last-row">
            <i
              aria-label="Discounts icon"
              className="icon-discount"
              role="presentation"
            />
            <span className="large-description">
              Discounts on DVD, Stream Purchases &amp; Merchandise
            </span>
          </div>
          {!this.props.upgrading && (
            <div className="row tagline">
              <span className="large-description bottom-tagline">
                Select a plan and start your {this.props.currentPlanName}
                {!this.props.usedFreeTrial && (
                  <span className="accent">7-Day Free Trial</span>
                )}
                {this.props.usedFreeTrial && (
                  <span className="accent">Subscription</span>
                )}
              </span>
            </div>
          )}
          {this.props.upgrading && <div className="row" />}
        </div>
        {this.props.plans.filter(this.filterSubscriptionPlans).map((plan) => {
          const isProrated = !(
            _.size(
              _.filter(this.props.plans, (p) => p.firstMonthPrice !== null)
            ) === 0
          )
          const { loading } = this.props
          const planName = plan.name.toLowerCase()
          const showButton =
            (this.props.currentPlan || !this.props.upgrading) &&
            this.props.currentPlan !== plan.rank &&
            plan.rank > 0 &&
            this.props.currentPlan < 3

          return (
            <div
              key={plan.id}
              className={classnames('col plan', {
                'group-plan': plan.rank === 4,
                'no-group-plan':
                  this.props.changeSubscription && plan.rank === 4,
                'global-promo': isGlobalPromoEnabled
              })}
            >
              <div
                className={`row header ${this.props.currentPlan === plan.rank ? 'current' : ''}`}
                onClick={
                  plan.name === 'Group Learning'
                    ? () => {
                        window.location.href =
                          'https://pages.stanwinstonschool.com/group-subscription-info-request-v2-swsca'
                      }
                    : this.props.currentPlan === plan.rank
                      ? null
                      : this.props.upgrading
                        ? () =>
                            this.props.upgradeAction(
                              this.props.plans,
                              plan,
                              this.props.currentPlan
                            )
                        : () => this.props.selectPlan(plan)
                }
              >
                <div className="icons-container">
                  {new Array(plan.rank > 3 ? 3 : 1)
                    .fill(null)
                    .map((_, iconIndex) => (
                      <i
                        key={iconIndex}
                        aria-label={`${plan.name} plan icon`}
                        className={getPlanIcon(plan.name)}
                        role="presentation"
                      />
                    ))}
                </div>
                <span className="plan-name">{plan.name}</span>
                {plan.rank > 3 && <span className="price-empty" />}
                {plan.rank < 4 && (
                  <span className="price">
                    ${this.getDiscountedPrice(plan)}
                    /Mo
                  </span>
                )}
                {plan.rank < 4 &&
                  (planName === 'yearly' || planName === 'annual') && (
                    <span className="price-before">
                      {this.getMonthlyStrikethroughPrice()}/Mo
                    </span>
                  )}
                {isGlobalPromoEnabled && plan.rank < 3 && (
                  <span className="price-before">
                    ${plan.price}
                    {(planName === 'yearly' || planName === 'annual') && '/Yr'}
                    {(planName === 'monthly' || planName === 'apprentice') &&
                      '/Mo'}
                  </span>
                )}
                {(plan.name === 'Yearly' || plan.name === 'annual') && (
                  <span className="special-description">
                    {isGlobalPromoEnabled &&
                    globalPromo.plans &&
                    globalPromo.plans[plan.id]
                      ? `$${globalPromo.plans[plan.id].priceDiscount} billed yearly`
                      : '$399.99 billed yearly'}
                  </span>
                )}
                {plan.name === 'Group Learning' && (
                  <span className="special-description">
                    Significant savings!
                  </span>
                )}
              </div>
              <div className="row main-description">
                {this.htmlParser(plan.description1)}
              </div>
              {isGlobalPromoEnabled && (
                <div className="row">
                  <span>
                    <i
                      aria-label="Check icon"
                      className="icon-checkmark"
                      role="presentation"
                    />
                  </span>
                </div>
              )}
              <div className="row">
                <i
                  aria-label="Check icon"
                  className="icon-checkmark"
                  role="presentation"
                />
              </div>
              {isGlobalPromoEnabled && (
                <div className="row">
                  <i
                    aria-label="Check icon"
                    className="icon-checkmark"
                    role="presentation"
                  />
                </div>
              )}
              <div
                className={classnames('row', {
                  'last-row': isGlobalPromoEnabled
                })}
              >
                {isGlobalPromoEnabled && plan.rank === 3 && (
                  <i
                    aria-label="Check icon"
                    className="icon-checkmark"
                    role="presentation"
                  />
                )}
                {!isGlobalPromoEnabled && (
                  <i
                    aria-label="Check icon"
                    className="icon-checkmark"
                    role="presentation"
                  />
                )}
                {isGlobalPromoEnabled &&
                  (plan.rank === 2 || plan.rank === 4) && <span>No</span>}
              </div>
              {!isGlobalPromoEnabled && (
                <div className="row">
                  {(plan.rank === 1 || plan.rank === 2) && plan.description2}
                  {plan.rank === 3 && <span className="highlight">FREE</span>}
                  {plan.rank === 4 && (
                    <i
                      aria-label="Check icon"
                      className="icon-checkmark"
                      role="presentation"
                    />
                  )}
                </div>
              )}
              {!isGlobalPromoEnabled && (
                <div
                  className={classnames('row', {
                    'last-row': !isGlobalPromoEnabled
                  })}
                >
                  <span className={classnames({ highlight: plan.rank === 3 })}>
                    {plan.rank === 3 ? plan.description2 : 'No'}
                  </span>
                </div>
              )}
              {this.props.upgrading &&
                ((plan.rank > this.props.currentPlan &&
                  plan.firstMonthPrice &&
                  isProrated) ||
                  this.props.currentPlan === plan.rank) && (
                  <div className="row">
                    {plan.rank > this.props.currentPlan &&
                      plan.firstMonthPrice &&
                      isProrated &&
                      plan.price - plan.firstMonthPrice > 0 && (
                        <span className="upgrade-plan">
                          Save ${(plan.price - plan.firstMonthPrice).toFixed(2)}{' '}
                          on your first payment
                        </span>
                      )}
                    {this.props.currentPlan === plan.rank && (
                      <span className="current-plan">current plan</span>
                    )}
                  </div>
                )}
              {(((this.props.currentPlan !== 3 ||
                plan.rank < 3 ||
                !this.props.upgrading) &&
                plan.firstMonthPrice) ||
                this.props.currentPlan !== plan.rank) && (
                <div
                  className={classnames('row', {
                    'simple-plan': plan.rank < 3
                  })}
                >
                  {!isGlobalPromoEnabled && (
                    <>
                      {plan.rank > this.props.currentPlan &&
                        this.props.upgrading &&
                        showButton &&
                        plan.rank < 4 && (
                          <button
                            aria-label={`${this.props.isSubscribed ? 'Upgrade' : 'Subscribe'} to ${plan.name} plan`}
                            className="btn -thin -border-white"
                            onClick={() =>
                              this.props.upgrading
                                ? this.props.upgradeAction(
                                    this.props.plans,
                                    plan,
                                    this.props.currentPlan
                                  )
                                : this.props.selectPlan(plan)
                            }
                            disabled={this.props.loading > 0}
                          >
                            {this.props.isSubscribed ? 'upgrade' : 'subscribe'}
                          </button>
                        )}
                      {!this.props.upgrading &&
                        showButton &&
                        plan.rank < 4 &&
                        this.props.usedFreeTrial && (
                          <button
                            aria-label={`Subscribe to ${plan.name} plan`}
                            className="btn -thin -border-white"
                            onClick={() => this.props.selectPlan(plan)}
                          >
                            Subscribe
                          </button>
                        )}
                      {!this.props.upgrading &&
                        showButton &&
                        plan.rank < 4 &&
                        !this.props.usedFreeTrial && (
                          <button
                            aria-label={`Subscribe to ${plan.name} plan`}
                            className="btn -thin -border-white"
                            onClick={() => this.props.selectPlan(plan)}
                          >
                            7-Day Free Trial
                          </button>
                        )}
                    </>
                  )}
                  {isGlobalPromoEnabled && (
                    <>
                      {!this.props.upgrading &&
                        showButton &&
                        plan.rank < 4 &&
                        !this.props.usedFreeTrial && (
                          <button
                            aria-label={`Subscribe to ${plan.name} plan`}
                            className="btn -thin -border-white"
                            onClick={() => this.props.selectPlan(plan)}
                          >
                            Subscribe &amp; save {globalPromo.discount}
                            {globalPromo.discountType === 'pctg' && '%'}
                          </button>
                        )}
                    </>
                  )}
                  {plan.rank > 3 && (
                    <a
                      aria-label="Learn more about group plans"
                      className="btn -thin -border-white link-btn"
                      href="https://pages.stanwinstonschool.com/group-subscription-info-request-v2-swsca"
                    >
                      Learn more
                    </a>
                  )}
                </div>
              )}
            </div>
          )
        })}
      </section>
    )
  }

  renderMobile() {
    const { globalPromo, isGlobalPromoEnabled } = this.props
    const plans = this.props.plans.filter(this.filterSubscriptionPlansMobile)

    return (
      <section id="SubscriptionPlanListMobile">
        <div className="sticky">
          {plans.map((plan) => {
            const isProrated = !(
              _.size(_.filter(plans, (p) => p.firstMonthPrice !== null)) === 0
            )
            const planName = plan.name.toLowerCase()
            const showButton =
              (this.props.currentPlan || !this.props.upgrading) &&
              this.props.currentPlan !== plan.rank &&
              plan.rank > 0 &&
              this.props.currentPlan < 3

            return (
              <div
                key={plan.id}
                className={classnames('col plan', {
                  'no-group-plan': this.props.isMobile && plan.rank === 4,
                  'global-promo': isGlobalPromoEnabled
                })}
              >
                <div
                  className={classnames('row header', {
                    'special-plan': plan.rank === 3,
                    'global-promo': isGlobalPromoEnabled
                  })}
                >
                  <i className={getPlanIcon(plan.name)} />
                  <span className="plan-name">{plan.name}</span>
                  <span className="price">
                    ${this.getDiscountedPrice(plan)}
                    <span>/Mo</span>
                  </span>
                  {(planName === 'yearly' || planName === 'annual') && (
                    <span className="price-before">
                      {this.getMonthlyStrikethroughPrice()}/Mo
                    </span>
                  )}
                  {planName === 'monthly' && isGlobalPromoEnabled && (
                    <span className="price-before">$59.99/Mo</span>
                  )}
                  {planName === 'monthly' && !isGlobalPromoEnabled && (
                    <span className="price-before placeholder">&nbsp;</span>
                  )}
                  <span className="large-description">
                    {(planName === 'yearly' || planName === 'annual') &&
                      isGlobalPromoEnabled &&
                      globalPromo.plans &&
                      globalPromo.plans[plan.id] &&
                      `$${globalPromo.plans[plan.id].priceDiscount} billed yearly`}
                    {(planName === 'yearly' || planName === 'annual') &&
                      !isGlobalPromoEnabled &&
                      '$399.99 billed yearly'}
                    {planName === 'monthly' && <>&nbsp;</>}
                  </span>
                </div>
                <div className="row current-plan">
                  {this.props.currentPlan === plan.rank &&
                    this.props.upgrading &&
                    plan.rank <= this.props.currentPlan && (
                      <span className="current-plan">current plan</span>
                    )}
                </div>
                <div
                  className={classnames('row cta', {
                    'simple-plan': plan.rank < 3
                  })}
                >
                  {!isGlobalPromoEnabled && showButton && (
                    <>
                      {plan.rank > this.props.currentPlan &&
                        this.props.upgrading && (
                          <button
                            className="btn -thin -border-white"
                            onClick={() =>
                              this.props.upgrading
                                ? this.props.upgradeAction(
                                    this.props.plans,
                                    plan,
                                    this.props.currentPlan
                                  )
                                : this.props.selectPlan(plan)
                            }
                          >
                            {this.props.isSubscribed ? 'upgrade' : 'subscribe'}
                          </button>
                        )}
                      {!this.props.upgrading && this.props.usedFreeTrial && (
                        <button
                          className={classnames('btn -thin', {
                            '-orange': plan.rank === 3,
                            '-border-white': plan.rank < 3
                          })}
                          onClick={() => this.props.selectPlan(plan)}
                        >
                          Subscribe
                        </button>
                      )}
                      {!this.props.upgrading && !this.props.usedFreeTrial && (
                        <button
                          className={classnames('btn -thin', {
                            '-orange': plan.rank === 3,
                            '-border-white': plan.rank < 3
                          })}
                          onClick={() => this.props.selectPlan(plan)}
                        >
                          7-Day Free Trial
                        </button>
                      )}
                    </>
                  )}
                  {isGlobalPromoEnabled && showButton && (
                    <>
                      {!this.props.upgrading && !this.props.usedFreeTrial && (
                        <button
                          className={classnames('btn -thin', {
                            '-orange': plan.rank === 3,
                            '-border-white': plan.rank < 3
                          })}
                          onClick={() => this.props.selectPlan(plan)}
                        >
                          Subscribe &amp; save {globalPromo.discount}
                          {globalPromo.discountType === 'pctg' && '%'}
                        </button>
                      )}
                    </>
                  )}
                </div>
                <div className="row savings">
                  {plan.rank > this.props.currentPlan &&
                    plan.firstMonthPrice &&
                    isProrated &&
                    plan.price - plan.firstMonthPrice > 0 && (
                      <span className="upgrade-plan">
                        Save ${(plan.price - plan.firstMonthPrice).toFixed(2)}{' '}
                        on your first payment
                      </span>
                    )}
                </div>
              </div>
            )
          })}
        </div>
        <div className="col large main-table">
          {!isGlobalPromoEnabled && (
            <div className="row">
              <div className="checkboxes">
                <div className="checkbox" />
                <div className="checkbox">
                  <i className="icon-checkmark" />
                </div>
              </div>
            </div>
          )}
          {!isGlobalPromoEnabled && (
            <div className="row">
              <span className="large-description">First 7 days are free</span>
              <div className="checkboxes">
                <div className="checkbox">
                  <i className="icon-checkmark" />
                </div>
                <div className="checkbox">
                  <i className="icon-checkmark" />
                </div>
              </div>
            </div>
          )}
          <div className="row">
            <span className="large-description">
              Access our On-Demand Course library
            </span>
            <div className="checkboxes">
              {plans.map((plan) => (
                <div className="checkbox" key={plan.id}>
                  {plan.name === 'Monthly' && (
                    <span className="text">Unlimited</span>
                  )}
                  {plan.name === 'Yearly' && (
                    <span className="text">Unlimited</span>
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className="row">
            <span className="large-description">Accces to Pathways</span>
            <div className="checkboxes">
              <div className="checkbox">
                <i className="icon-checkmark" />
              </div>
              <div className="checkbox">
                <i className="icon-checkmark" />
              </div>
            </div>
          </div>
          <div className="row">
            <span className="large-description">
              Watch on your computer, phone, or tablet
            </span>
            <div className="checkboxes">
              <div className="checkbox">
                <i className="icon-checkmark" />
              </div>
              <div className="checkbox">
                <i className="icon-checkmark" />
              </div>
            </div>
          </div>
          {!isGlobalPromoEnabled && (
            <div className="row">
              <span className="large-description">Live Course Discounts</span>
              <div className="checkboxes">
                <div className="checkbox">
                  <span className="text">
                    {plans[0] && plans[0].description2}
                  </span>
                </div>
                <div className="checkbox">
                  {!isGlobalPromoEnabled && (
                    <span className="text highlight">FREE</span>
                  )}
                  {isGlobalPromoEnabled && <i className="icon-checkmark" />}
                </div>
              </div>
            </div>
          )}
          <div className="row">
            <span className="large-description">
              Discounts on DVD, Stream Purchases &amp; Merchandise
            </span>
            <div className="checkboxes">
              <div className="checkbox">
                <span className="text">No</span>
              </div>
              <div className="checkbox">
                {!isGlobalPromoEnabled && (
                  <span className="text highlight">
                    {plans[0] && plans[0].description2}
                  </span>
                )}
                {isGlobalPromoEnabled && (
                  <span className="text">
                    <div className="checkbox">
                      <i className="icon-checkmark" />
                    </div>
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }

  render() {
    const { isMobile } = this.props
    return isMobile ? this.renderMobile() : this.renderDesktop()
  }
}

export const SubscriptionPlanPropTypes = {
  url: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  trial: PropTypes.string,
  description_1: PropTypes.string,
  description_2: PropTypes.string,
  description_3: PropTypes.string,
  price: PropTypes.number.isRequired,
  owned: PropTypes.bool.isRequired
}

SubscriptionPlanList.propTypes = {
  plans: PropTypes.arrayOf(PropTypes.shape(SubscriptionPlanPropTypes))
    .isRequired,
  upgrading: PropTypes.bool,
  currentPlan: PropTypes.number,
  isSubscribed: PropTypes.bool,
  currentPlanName: PropTypes.string,
  isMobile: PropTypes.bool,
  loading: PropTypes.number,
  closeBannerSubscription: PropTypes.func,
  openBannerSubscription: PropTypes.func,
  router: PropTypes.object,
  globalPromo: PropTypes.shape({
    codename: PropTypes.string,
    discount: PropTypes.number,
    discountType: PropTypes.string,
    plans: PropTypes.shape({
      id: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        price: PropTypes.number,
        discountAmount: PropTypes.number,
        priceDiscount: PropTypes.number
      })
    })
  })
}

SubscriptionPlanList.defaultProps = {
  plans: [],
  upgrading: false,
  isSubscribed: false,
  currentPlanName: '',
  currentPlan: 0,
  globalPromo: {
    codename: '',
    discount: 0,
    discountType: '',
    plans: {}
  }
}

export default connect(stateSelector, dispatchSelector)(SubscriptionPlanList)
